import { Dispatch, ReactNode } from 'react';
import { connect } from 'react-redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import {
    IAddressRequest,
    IAddressUpdateRequest,
    IAddressFieldConfig,
} from '../address/address.interface';
import { AddressesActions } from '../addressesActions';
import { AddressesAction } from '../addressesActionType';
import AddressForm from './AddressForm';
import { NotificationsActions } from '../../../app/common/notifications/notificationsActions';
import SupportLanguageHelper from '../../../utils/SupportLanguageHelper';
import SortHelpers from '../../../utils/sortHelpers';
import FieldHelper from '../../../utils/fieldHelper';

function mapStateToProps(state: IReduxRootState) {
    const {
        locale,
        presentationConfig: {
            visibleFields: { address },
        },
    } = state.app;
    const challengerDegenerate = state.app.appConfig.CHALLENGER_DEGENERATE;
    const lang = SupportLanguageHelper.getSupportLanguage(locale);
    const addressFieldConfig = Object.values(address).sort((a, b) => {
        return SortHelpers.sortAddressFieldAscendingOrder(
            a as IAddressFieldConfig,
            b as IAddressFieldConfig,
            lang,
        );
    }) as IAddressFieldConfig[];
    const groupedAddressFieldConfig = FieldHelper.groupField(addressFieldConfig);
    return {
        loading: state.addresses.loading,
        defaultCountry: state.app.clientConfig.countryCode,
        addressFieldConfig: groupedAddressFieldConfig,
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.ADDRESS
            : '',
        challengerDegenerate,
    };
}

function mapDispatchToProps(dispatch: Dispatch<AddressesAction>) {
    return {
        addAddress: (address: IAddressRequest) => {
            dispatch(AddressesActions.addAddress(address));
        },
        updateAddress: (addressUuid: string, updatedAddress: IAddressUpdateRequest) => {
            dispatch(AddressesActions.updateAddress(addressUuid, updatedAddress));
        },
        showWarning: (message: ReactNode) => {
            dispatch(NotificationsActions.showWarning(message));
        },
    };
}

const AddressFormContainer = connect(mapStateToProps, mapDispatchToProps)(AddressForm);

export default AddressFormContainer;
